
// https://codepen.io/anon/pen/rRWaqm

import { Geometry, Log, LogGroup, now, Point, Rect, Scale, Size, Vec2d } from ".././MyHelpers";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { MyCanvas } from "./MyCanvas";
import { Sprite } from "./Sprite/Sprite";

export abstract class FountainParticle {
	private viewSize: Size = new Size(0, 0);

	private particleSize: Size = null;
	private source: Point = new Point(0, 0);

	public position: Point = new Point(0, 0);
	public velocity: Vec2d = new Vec2d(0, 0);
	public acceleration: Vec2d = new Vec2d(0, 0);
	
	// particle angle around its own axis
	public angle: number = 0;
	public angleVelocity: number = 0;

	//active = was already shot up, but hasn't landed yet
	public active: boolean = false;

	// delay when shooting up so that they don't go all up at the same time randomly generated
	public shootDelay: number = 0;
	public created: number = 0;

	public lastMotionUpdate = 0;

	constructor(viewSize: Size, particleSize: Size, shootDelay: number) {
		this.viewSize = viewSize;
		this.source.x = this.viewSize.Width / 2;
		this.source.y = this.viewSize.Height;

		this.particleSize = particleSize;

		this.shootDelay = shootDelay;
		this.created = now();
	}

	// make particle active and give it a velocity so that 
	// it can start moving
	Shoot(millis: number, started: number, acceleration:number): boolean {


		// check if time for shooting this particle has arrived
		if (millis - started >= this.shootDelay && !this.active) {

			//// Log.Debug("FountainParticle", "Shoot");

			// make it active
			this.active = true;

			// position it at the fountain source, 
			// but a bit lower, depending on its radius
			this.position.x = this.source.x + Fountain.rand(-10, 10);
			this.position.y = this.source.y;

			// give it an acceleration considering gravity
			// and uniform friction (depending on its radius)
			this.acceleration.x = 0;
			//this.acceleration.y = 0.6; //0.016 * 1000;
			this.acceleration.y = acceleration;

			// generate a random angle at which it shoots up
			let angle = Fountain.rand(Math.PI / 22, -Math.PI / 22) - Math.PI / 2;

			// Set up our confetti particle angle 
			//this.angle = 0;
			this.angleVelocity = (Fountain.rand(-70, 70) / 2) 

			// generate random velocity absolute value in that direction
			//let val = Fountain.rand(this.viewSize.height / 21, this.viewSize.height / 60) / 100;

			//let val = Fountain.rand(this.viewSize.height / 21, this.viewSize.height / 60) / 1000;
			let val = Fountain.rand(this.viewSize.Height/51, this.viewSize.Height/100) / 1;

			// compute initial velocity components
			this.velocity.x = Math.cos(angle) * val;
			this.velocity.y = Math.sin(angle) * val;

			this.lastMotionUpdate = now();

			return true;
		}
		else {
			return false;
		}
	};


	

	// particle is in motion, update its velocity and position
	public MotionUpdate(millis: number): void {
		/*
		 * velocity_incr = acceleration * time_incr
		 * position_incr = velocity * time_incr
		 * but time_incr = 1 in our case
		 * (see the t++ line in drawOnCanvas)
		 * so compute new velocity and position components
		 * based on this
		 */
		let motionFactor: number = ((millis - this.lastMotionUpdate) / 1000) * 8;

		this.velocity.x += this.acceleration.x * motionFactor;
		this.velocity.y += this.acceleration.y * motionFactor;
		this.position.x += Math.round(this.velocity.x * motionFactor);
		this.position.y += Math.round(this.velocity.y * motionFactor);
		this.angle += this.angleVelocity;

		//// Log.Debug("FountainParticle", " position: " + JSON.stringify(this.position) + " velocity: " + JSON.stringify(this.position) + ", angle: " + this.angle);

		// if it has landed = it's below canvas bottom edge
		if (this.position.y > this.viewSize.Height || this.position.x < 0 || this.position.x > this.viewSize.Width) {
		//if (this.position.y > this.viewSize.height + this.particleSize.height) {

			// reset position to the initial one
			this.position.x = this.source.x; //Fountain.rand(this.fountainData.source.xMin, this.fountainData.source.xMax),
			this.position.y = this.source.y;

			// ... and make this particle inactive
			this.active = false;
		}
	};

	public Draw(canvas: MyCanvas): void {
		// have nothing to draw here...
		// implement in subclass
	}
};

export class FountainParticleWithSprite extends FountainParticle {

	protected sprite: Sprite;
	protected spriteSize: Size;

	public constructor(viewSize: Size, shootDelay: number, sprite: Sprite, spriteSize: Size) {
		super(viewSize, spriteSize, shootDelay);

		this.sprite = sprite;
		this.spriteSize = spriteSize;
	}

	public Update(): void {
		this.sprite.Update();
	}

	public Restart(): void {
		this.sprite.Restart();
	}

	public Stop(): void {
		this.sprite.Stop();
	}

	public override Shoot(millis: number, started: number, acceleration:number ): boolean {
		let shootResult = super.Shoot(millis, started, acceleration);

		if (shootResult) {
			this.sprite.Restart();
			this.sprite.SetFPS(Fountain.rand(5, 30));
		}

		return shootResult;
	}

	public override Draw(canvas: MyCanvas): void {

		//canvas.context.save();

		canvas.context.resetTransform();
		canvas.context.translate(this.position.x , this.position.y );
		canvas.context.rotate(this.angle * Math.PI / 180);

		//// Log.Debug("test", this.sprite.CurrentFrameIndex());

		let src: Rect = this.sprite.CurrentFrameRect;
		canvas.context.drawImage(this.sprite.CurrentFrame, 
			src.x, src.y, src.width, src.height,
			- (this.spriteSize.Width /2), - (this.spriteSize.Height /2), this.spriteSize.Width, this.spriteSize.Height
		);

		//canvas.context.restore();
	}

	override MotionUpdate(millis: number) {

		// update velocity and position
		super.MotionUpdate(millis);

		// update frame
		this.sprite.Update(millis);
	}
}


export type FountainStartCallback = () => void;
export type FountainStopCallback = () => void;

export class Fountain {

	private viewSize: Size = null;
	private canvas: MyCanvas = null;
	private N_PARTICLES: number = 50;

	private sprite: Sprite = null;
	private spriteSize: Size = null;
	private particles2: FountainParticleWithSprite[] = [];

	private source: Point = new Point(0, 0);

	private running: boolean = false;
	private requestStop: boolean = false;

	private lastMotionUpdate: number = 0;

	protected logGroup: LogGroup;
    protected resid: ResourceIdentifier;
	protected started: number = 0;
	protected readonly defaultAcceleration: number = 0;
	protected acceleration: number = 0;

	constructor(logGroup: LogGroup, resid: ResourceIdentifier, viewSize: Size, sprite: Sprite, desiredSpriteSize: Size, acceleration:number) {
		this.logGroup = logGroup.Add("Fountain");
        this.resid = resid.Add("Fountain");

		this.viewSize = viewSize;
		this.sprite = sprite;
		// fit sprite size into desired sprite size
		this.spriteSize = Geometry.FitRect(Rect.FromSize(sprite.Size()),  Rect.FromSize(desiredSpriteSize)).Size();
		this.defaultAcceleration = acceleration;
		this.acceleration = this.defaultAcceleration;

		this.canvas = new MyCanvas(this.viewSize, {
            classes: [resid.ID()],
            style: {
                position: "absolute",
                bottom: Scale.ZERO_PX,
                left: Scale.ZERO_PX,
                pointerEvents: "none",
                visibility: "none"
            }
        });

		this.source = new Point(this.viewSize.Width / 2, this.viewSize.Height);

		// prepare particles
		for (let i = 0; i < this.N_PARTICLES; i++) {
			let delay = Fountain.rand(this.N_PARTICLES * this.N_PARTICLES, 0, true);

			//// Log.Debug(this.logGroup, "Delay: " + delay);

			this.particles2.push(new FountainParticleWithSprite(
				this.viewSize,
				delay,
				this.sprite.Copy(),
				this.spriteSize
			));
		}
	}


	static rand(_max: number, _min: number, _int: boolean = false): number {
		let max = (_max === 0 || _max) ? _max : 1;
		let min = _min || 0;
		let gen = min + (max - min) * Math.random();

		return (_int) ? Math.round(gen) : gen;
	};

	// goes through the particle array and
	// may call a particle's draw function
	Update(): void {
		if (this.running) {

			let continueRunning: boolean = true;

			let millis: number = now();
			//if (millis - this.lastMotionUpdate >= 30) 
			{

				let anyParticleActive: boolean = false;

				this.canvas.context.resetTransform();
				this.canvas.Clear();
				//this.data.ctx.clearRect(0, 0, this.data.w, this.data.h);	

				// go through each particle in the particle array
				for (let i = 0; i < this.N_PARTICLES; i++) {
					if (this.particles2[i].active) { // if it's active
						anyParticleActive = true;

						this.particles2[i].Draw(this.canvas); // draw it on canvas
						this.particles2[i].MotionUpdate(millis);
					} 
					else if (!this.requestStop) { // if not...
						this.particles2[i].Shoot(millis, this.started, this.acceleration); // try to make it shoot up
					}
				}
				
				this.lastMotionUpdate = millis;

				if (this.requestStop && !anyParticleActive) {
					// we have finished
					continueRunning = false;
				}
			}
			
			if (!continueRunning) {
				this.OnStopped();
			}
		}
	};

	protected owner: ResourceIdentifier = null;
	public Start(owner: ResourceIdentifier, acceleration: number = -1): void {

		if (this.running)
		{
			Log.Error(this.logGroup, "Already running, owner: " + owner.ID());
		}

		if (acceleration != -1)
		{
			this.acceleration = acceleration;
			// Log.Debug(this.logGroup, "Started with acceleration " + acceleration);
		}
		else
		{
			this.acceleration = this.defaultAcceleration;
			// Log.Debug(this.logGroup, "Started with default acceleration " + this.defaultAcceleration);
		}

		this.owner = owner;
		this.running = true;
		this.requestStop = false;
		this.started = now();

		this.OnStarted();
	}
	
	// request gentle stop
	public RequestStop(owner: ResourceIdentifier): void {
		// Log.Debug(this.logGroup, "Stop requested");
		
		// not running
		if (!this.running)
		{
			// Log.Debug(this.logGroup, "Not running");
			return;
		}

		// stop laready requested
		if (this.requestStop)
		{
			// Log.Debug(this.logGroup, "Stop already requested");
			return;
		}

		if (this.owner && owner.ID() != this.owner.ID())
		{
			Log.Error("Stop requested by: " + owner.ID(), ", owner is: " + this.owner.ID());
		}

		this.requestStop = true;
	}

	public Running(): boolean
	{
		return this.running;
	}

	public View(): HTMLElement {
		return this.canvas.view;
	}

	protected onStartCallbacks: Map<string, FountainStartCallback> = new Map<string, FountainStartCallback>();
	protected OnStarted(): void {
		// Log.Debug(this.logGroup, "Started");

		let cb = this.onStartCallbacks.get(this.owner.ID())
		if (cb)
		{
			cb();
		}
	}

	public AddOnStartCallback(owner: ResourceIdentifier, callback: FountainStartCallback): void {
		this.onStartCallbacks.set(owner.ID(), callback);
	}

	protected onStopCallbacks: Map<string, FountainStopCallback> = new Map<string, FountainStopCallback>();
	protected OnStopped(): void {
		// Log.Debug(this.logGroup, "Stopped");
		this.running = false;

		let lastOwner = this.owner;
		this.owner = null;

		let cb = this.onStopCallbacks.get(lastOwner.ID())
		if (cb)
		{
			cb();
		}
	}

	public AddOnStopCallback(owner: ResourceIdentifier, callback: FountainStopCallback): void {
		this.onStopCallbacks.set(owner.ID(), callback);
	}
}

export class FountainAnimation extends Fountain {

}